<template>
    <div class="block">
        <div class="select">
            <select v-model="deliveryMode">
                <option value="self">Self Collection</option>
                <option value="driving">Driving Delivery</option>
                <option value="walking">Walking Delivery</option>
            </select>
        </div>
        <div class="select" v-if="deliveryMode == 'driving' || deliveryMode == 'walking'">
            <div v-if="deliveryMode == 'driving'">
                <select v-model="teamName">
                    <option v-for="team in drivingTeamNames" :key="team">{{ team }}</option>
                </select>
            </div>
            <div v-if="deliveryMode == 'walking'">
                <select v-model="teamName">
                    <option v-for="team in walkingTeamNames" :key="team">{{ team }}</option>
                </select>
            </div>
        </div>
    </div>
    <div v-if="!!error" class="notification is-danger is-light">
        <p><b>Something went wrong!</b></p>
        <p>{{ error }}</p>
    </div>
    <div class="justify-center">
        <button @click="updateDelivery" :class="[isLoading ? 'is-loading' : '']"
            class="button is-warning is-rounded">Update</button>
    </div>
</template>

<script>
export default {
    data() {
        return {
            deliveryMode: 'self',
            teamName: this.deliveryTeam,
            error: null,
            isLoading: false
        }
    },
    props: ['fdID', 'deliveryID', 'selfCollection', 'drivingDelivery', 'drivingTeams', 'walkingTeams', 'deliveryTeam'],
    created() {
        this.evaluateDeliveryMode();
    },
    methods: {
        evaluateDeliveryMode() {
            if (this.selfCollection) {
                this.deliveryMode = 'self'
            } else if (this.drivingDelivery) {
                this.deliveryMode = 'driving'
            } else {
                this.deliveryMode = 'walking'
            }
        },
        async updateDelivery() {
            this.isLoading = true;
            var selfCollection;
            var drivingDelivery;
            if (this.deliveryMode == 'self') {
                selfCollection = true;
                drivingDelivery = false;
                this.teamName = '';
            } else {
                selfCollection = false;
                if (this.deliveryMode == 'driving') {
                    drivingDelivery = true;
                }
                else {
                    drivingDelivery = false;
                }
            }
            try {
                await this.$store.dispatch('delivery/updateDeliveryModeAndTeam', {
                    fdID: this.fdID,
                    deliveryID: this.deliveryID,
                    deliveryTeam: this.teamName,
                    selfCollection: selfCollection,
                    drivingDelivery: drivingDelivery
                });
            } catch (error) {
                this.error = error;
            }
            this.isLoading = false;
        }
    },
    computed: {
        drivingTeamNames() {
            var teamNames = [];
            for (let i = 1; i <= this.drivingTeams; i++) {
                teamNames.push("driving" + i);
            }
            return teamNames;
        },
        walkingTeamNames() {
            var teamNames = [];
            for (let i = 1; i <= this.walkingTeams; i++) {
                teamNames.push("walking" + i);
            }
            return teamNames;
        }
    }
}
</script>

<style scoped>
.justify-center {
    text-align: center;
}
</style>